import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { Colors } from "../theme";

export const SwitchContainer = styled(Box)(() => ({
  "& .switch": {
    position: "relative",
    display: "inline-block",
    width: "48px",
    height: "20px",
    backgroundColor: Colors.light_gray,
    borderRadius: "12px",
    cursor: "pointer",
    padding: "2px",
    transition: "background-color 0.2s",
    opacity: 1,
  },
  "& .switch.active": {
    backgroundColor: Colors.primary,
  },
  "& .switch-handle": {
    position: "absolute",
    top: "2.2px",
    left: "2.2px",
    width: "16px",
    height: "16px",
    backgroundColor: Colors.white,
    borderRadius: "10px",
    transition: "0.2s",
  },
  "& .switch.active .switch-handle": {
    transform: "translateX(28px)",
  },
  "& .switch.disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },
}));
